// Keyboard keys constants
export const ARROW_DOWN = 'ArrowDown'
export const ARROW_LEFT = 'ArrowLeft'
export const ARROW_RIGHT = 'ArrowRight'
export const ARROW_UP = 'ArrowUp'
export const BACKSPACE = 'Backspace'
export const DELETE = 'Delete'
export const END = 'End'
export const ENTER = 'Enter'
export const ESCAPE = 'Escape'
export const HOME = 'Home'
export const PAGE_DOWN = 'PageDown'
export const PAGE_UP = 'PageUp'
export const SPACE = ' '
export const TAB = 'Tab'

// Keyboard event types
export const KEYDOWN_EVENT = 'keydown'
export const KEYUP_EVENT = 'keyup'
export const KEYPRESS_EVENT = 'keypress'
